import { render, staticRenderFns } from "./make-detail-dialog.vue?vue&type=template&id=1be79878&scoped=true&"
import script from "./make-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./make-detail-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be79878",
  null
  
)

export default component.exports